import { DateTimeInputWUT } from '@wix/form-fields/viewer-wut';

export default DateTimeInputWUT;
